import s from './no-attempts.module.scss';
import WarnIcon from '@/icons/states/warn.svg';

const NoAttempts = ({ time }: { time: number }) => {
  return (
    <div className={s.wrapper}>
      <WarnIcon />
      <div>
        <p className={s.title}>Daily limit reached</p>
        <p className={s.sub}>
          You’ve used up your free checks for today. Come back tomorrow to
          continue.
        </p>
      </div>
    </div>
  );
};
export default NoAttempts;
